module.exports = __webpack_public_path__ + "static/media/sort-arrow.63dbc6f4.svg";